import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { DEFAULT_SEARCH_AND_FILTER_VIEW_PLACEHOLDER } from '../../../search-and-filter-data/protected';
/**
 * @description This hook contains common functionality between useSearchAndFilterViewMembers
 * and useHelpDeskViewMembers. It should not be used directly by consumers, or anywhere else
 * outside of those two hooks.
 */
export const useViewMembersBase = ({
  customViewId,
  fetcher,
  filterGroups,
  hasMore,
  inboxId,
  loading,
  offsetId,
  offsetTimestamp,
  primaryOffsetValue,
  secondaryOffsetValue,
  searchQuery,
  skip,
  sortDirection = 'DESC',
  sortProperty
}) => {
  const dispatch = useDispatch();

  //Fetch results when a change is made to the view ID, filters, inbox ID, search query, or sort direction
  useEffect(() => {
    const hasFiltersOrSearchSet = filterGroups.length > 0 || searchQuery.length > 0;
    const isInSearchAndFilterPage = customViewId === DEFAULT_SEARCH_AND_FILTER_VIEW_PLACEHOLDER;
    if (inboxId && !skip && (customViewId && !isInSearchAndFilterPage || hasFiltersOrSearchSet)) {
      dispatch(fetcher({
        filterGroups,
        inboxId,
        searchQuery,
        sortDirection,
        sortProperty,
        limit: 100,
        viewId: `${customViewId}`
      }));
    }
  }, [customViewId, dispatch, fetcher, filterGroups, inboxId, searchQuery, skip, sortDirection, sortProperty]);

  //Create fetching functions
  const fetchMore = (limit = 100) => {
    if (inboxId && hasMore && !loading) {
      dispatch(fetcher({
        filterGroups,
        inboxId,
        offsetId,
        offsetTimestamp,
        primaryOffsetValue,
        secondaryOffsetValue,
        searchQuery,
        sortDirection,
        sortProperty,
        limit,
        viewId: `${customViewId}`
      }));
    }
  };
  const refetch = () => {
    if (inboxId) {
      dispatch(fetcher({
        filterGroups,
        inboxId,
        searchQuery,
        sortDirection,
        sortProperty,
        limit: 100,
        options: {
          disabledLoad: false,
          force: true
        },
        viewId: `${customViewId}`
      }));
    }
  };
  return {
    fetchMore,
    refetch
  };
};